export default "__VITE_ASSET__rH90AdwK__"